export default "__VITE_ASSET__DGEl2ryt__"